import { ref, readonly } from 'vue'
import axios from 'axios'

// Estado global compartilhado entre componentes
const formas = ref([
  'Não informado',
  'Google',
  'Instagram',
  'Facebook',
  'Doctorália',
  'Panfleto',
  'Email',
  'Indicação',
  'Outros Meios'
])
const carregado = ref(false)
const carregando = ref(false)

/**
 * Composable para gerenciar formas de captação
 * Busca da API e mantém cache local
 */
export function useFormasDeCaptacao() {

  async function carregar() {
    if (carregado.value || carregando.value) return formas.value

    carregando.value = true
    try {
      const response = await axios.get('/api/formas-de-captacao/nomes')
      if (response.data && Array.isArray(response.data) && response.data.length > 0) {
        formas.value = response.data
        carregado.value = true
      }
    } catch (error) {
      console.warn('Erro ao carregar formas de captação, usando fallback:', error.message)
    } finally {
      carregando.value = false
    }

    return formas.value
  }

  function recarregar() {
    carregado.value = false
    return carregar()
  }

  return {
    formas: readonly(formas),
    carregado: readonly(carregado),
    carregando: readonly(carregando),
    carregar,
    recarregar,
  }
}

// Valor padrão exportado para uso direto
export const CAPTACAO_PADRAO = 'Não informado'
